import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Field, reduxForm } from "redux-form";
import { Modal } from "components";
import { Button, Input } from "expano-components";
import { createAisle } from "actions/aisles";
import { useMainList } from "components/MainList/context/provider";

import { ReactComponent as EditIcon } from "icons/edit.svg";

const InputField = (props) => <Input {...props} />;

const ModalAddAisle = ({
  invalid,
  pristine,
  handleSubmit,
  handleClose,
}) => {
  const query = useQueryClient();
  const { refetch } = useMainList();
  const onSubmit = async (values) => {
    createAisle(values)
      .then(() => {
        refetch();
        query.refetchQueries(["warehouse_rooms"]);
        handleClose();
      })
      .catch((error) => console.log(error));
  };

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        icon: <EditIcon />,
        title: "Utwórz",
      }}
      footer={
        <>
          <Button
            type="cancel"
            text="Anuluj"
            onClick={handleClose}
          />
          <button
            disabled={invalid || pristine}
            onClick={handleSubmit(onSubmit)}
            type="submit"
            className="btn btn-sm btn-green">
            <span>Zapisz</span>
          </button>
        </>
      }>
      <form noValidate>
        <table className="modal-table">
          <tbody>
            <tr>
              <td>Nazwa</td>
              <td>
                <Field
                  placeholder="Nazwa"
                  name="name"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Skrót</td>
              <td>
                <Field
                  placeholder="Skrót"
                  name="identifier"
                  component={InputField}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane!";
  }
  if (!values.identifier) {
    errors.identifier = "Pole wymagane!";
  }
  if (values.identifier?.length > 3) {
    errors.identifier = "Maksymalnie 3 znaki";
  }
  return errors;
};

export default reduxForm({
  form: "add-aisle",
  validate,
  enableReinitialize: true,
})(ModalAddAisle);
